import { useCallback, useState } from "react";
import { FiltroExportacaoContabil } from "features/exportacao-contabil/typings";

export const filtroDefaultExportacaoContabil: FiltroExportacaoContabil = {
  dataInicio: undefined,
  dataFim: undefined,
  contasBancariasIds: undefined,
};

function useFiltroExportacaoContabil() {
  const [filtro, setFiltro] = useState<FiltroExportacaoContabil>(
    filtroDefaultExportacaoContabil
  );

  const onChangeFiltro = useCallback(
    (_filtro: Partial<FiltroExportacaoContabil>) => {
      setFiltro((state) => ({ ...state, ..._filtro }));
    },
    []
  );

  const onResetFiltro = useCallback(
    (_filtro: Partial<FiltroExportacaoContabil>) => {
      setFiltro({
        ...filtroDefaultExportacaoContabil,
        ..._filtro,
      });
    },
    []
  );

  return {
    filtro,
    setFiltro,
    onChangeFiltro,
    onResetFiltro,
  };
}

export default useFiltroExportacaoContabil;
